// @ts-nocheck

import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { IceHockeyGoalAnimationSprite } from '../../../assets/img/spritesheets';
import Spritesheet from '../../../components/Spritesheet';
import { type MatchScore } from '../../../types/match';

const ANIMATION_DURATION = 1400;

const SpritesheetOver = styled(Spritesheet)`
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translate(-50%, -40%);
  clip-path: inset(2px 0 0);
  mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 30%, rgba(0, 0, 0, 0) 100%);
`;

type IceHockeyGoalAnimationProps = {
  hasImage: boolean;
  height?: number | null;
  matchScore: MatchScore;
  onDone: () => void;
  onStart: () => void;
  width: number;
};

const IceHockeyGoalAnimation = ({
  width,
  matchScore,
  onStart,
  onDone,
  hasImage = false,
}: IceHockeyGoalAnimationProps) => {
  const [play, setPlay] = useState(0);
  const [score, setScore] = useState(null);

  const onAnimationDone = useCallback(() => {
    setPlay(0);
  }, []);

  useEffect(() => {
    const scoreString = JSON.stringify(matchScore);

    if (score === null) {
      return setScore(scoreString);
    }

    const savedScore = score ? JSON.parse(score) : null;

    if (matchScore.score1 === null || matchScore.score2 === null || score === scoreString) {
      return;
    }

    const newGoal = savedScore ? matchScore.score1 > savedScore.score1 || matchScore.score2 > savedScore.score2 : false;

    setScore(scoreString);

    if (!newGoal) {
      return;
    }

    setPlay(1);
  }, [score, onStart, matchScore]);

  const initializedRef = useRef();

  useEffect(() => {
    if (initializedRef.current) {
      if (play) {
        onStart();
      } else {
        onDone();
      }
    }

    initializedRef.current = true;
  }, [onDone, onStart, play]);

  if (!play) {
    return null;
  }

  return (
    <SpritesheetOver
      columnCount={7}
      duration={ANIMATION_DURATION}
      keepRatio
      play={play}
      loop={false}
      rowCount={7}
      url={IceHockeyGoalAnimationSprite}
      width={width / 2}
      onDone={onAnimationDone}
      $hasImage={hasImage}
      expires
    />
  );
};

export default IceHockeyGoalAnimation;
